export default __webpack_public_path__ + "static/our-technology-7c6f9f2d266e91758454f5fe90c091f7.jpg";